var GlobalCssClass;
(function (GlobalCssClass) {
  GlobalCssClass["FormElement"] = "iress-form-element";
  GlobalCssClass["FormElementInvalid"] = "iress-form-element--invalid";
  GlobalCssClass["SROnly"] = "iress-sr-only";
  GlobalCssClass["NoScroll"] = "iress-no-scroll";
  GlobalCssClass["Hidden"] = "iress-hidden";
  GlobalCssClass["IgnoreStack"] = "iress-stack--ignore";
  GlobalCssClass["TextAlignBase"] = "iress-text-align";
  GlobalCssClass["HiddenMobile"] = "iress-hidden--mobile";
})(GlobalCssClass || (GlobalCssClass = {}));
var TextFieldType;
(function (TextFieldType) {
  TextFieldType["Date"] = "date";
  TextFieldType["Email"] = "email";
  TextFieldType["Number"] = "number";
  TextFieldType["Password"] = "password";
  TextFieldType["Search"] = "search";
  TextFieldType["Tel"] = "tel";
  TextFieldType["Text"] = "text";
  TextFieldType["Url"] = "url";
  TextFieldType["Time"] = "time";
  TextFieldType["Color"] = "color";
  TextFieldType["File"] = "file";
})(TextFieldType || (TextFieldType = {}));
var FormElementType;
(function (FormElementType) {
  FormElementType["Date"] = "date";
  FormElementType["Email"] = "email";
  FormElementType["Number"] = "number";
  FormElementType["Password"] = "password";
  FormElementType["Search"] = "search";
  FormElementType["Tel"] = "tel";
  FormElementType["Text"] = "text";
  FormElementType["Url"] = "url";
  FormElementType["Time"] = "time";
  FormElementType["File"] = "file";
  FormElementType["Color"] = "color";
  FormElementType["Checkbox"] = "checkbox";
  FormElementType["Radio"] = "radio";
  FormElementType["Select"] = "select";
  FormElementType["CheckboxGroup"] = "checkbox-group";
  FormElementType["RadioGroup"] = "radio-group";
  FormElementType["Combobox"] = "combobox";
})(FormElementType || (FormElementType = {}));
var SystemValidationStatus;
(function (SystemValidationStatus) {
  SystemValidationStatus["Error"] = "error";
  SystemValidationStatus["Warning"] = "warning";
  SystemValidationStatus["Success"] = "success";
  SystemValidationStatus["Info"] = "info";
})(SystemValidationStatus || (SystemValidationStatus = {}));
var FieldErrorType;
(function (FieldErrorType) {
  FieldErrorType["BadInput"] = "badInput";
  FieldErrorType["PatternMismatch"] = "patternMismatch";
  FieldErrorType["RangeOverflow"] = "rangeOverflow";
  FieldErrorType["RangeUnderflow"] = "rangeUnderflow";
  FieldErrorType["TooLong"] = "tooLong";
  FieldErrorType["TooShort"] = "tooShort";
  FieldErrorType["StepMismatch"] = "stepMismatch";
  FieldErrorType["TypeMismatch"] = "typeMismatch";
  FieldErrorType["ValueMissing"] = "valueMissing";
})(FieldErrorType || (FieldErrorType = {}));
var CaptureValues;
(function (CaptureValues) {
  CaptureValues["User"] = "user";
  CaptureValues["Environment"] = "environment";
})(CaptureValues || (CaptureValues = {}));
var TextAlign;
(function (TextAlign) {
  TextAlign["Inherit"] = "inherit";
  TextAlign["Left"] = "left";
  TextAlign["Right"] = "right";
  TextAlign["Center"] = "center";
  TextAlign["Justify"] = "justify";
})(TextAlign || (TextAlign = {}));
var PaddingSize;
(function (PaddingSize) {
  PaddingSize["None"] = "none";
  PaddingSize["Sm"] = "sm";
  PaddingSize["Md"] = "md";
  PaddingSize["Lg"] = "lg";
})(PaddingSize || (PaddingSize = {}));
var Breakpoint;
(function (Breakpoint) {
  Breakpoint["Xs"] = "xs";
  Breakpoint["Sm"] = "sm";
  Breakpoint["Md"] = "md";
  Breakpoint["Lg"] = "lg";
  Breakpoint["Xl"] = "xl";
})(Breakpoint || (Breakpoint = {}));
var GlobalBreakpointMinWidth;
(function (GlobalBreakpointMinWidth) {
  GlobalBreakpointMinWidth[GlobalBreakpointMinWidth["Xs"] = 0] = "Xs";
  GlobalBreakpointMinWidth[GlobalBreakpointMinWidth["Sm"] = 576] = "Sm";
  GlobalBreakpointMinWidth[GlobalBreakpointMinWidth["Md"] = 768] = "Md";
  GlobalBreakpointMinWidth[GlobalBreakpointMinWidth["Lg"] = 1024] = "Lg";
  GlobalBreakpointMinWidth[GlobalBreakpointMinWidth["Xl"] = 1200] = "Xl";
})(GlobalBreakpointMinWidth || (GlobalBreakpointMinWidth = {}));
var HeadingLevel;
(function (HeadingLevel) {
  HeadingLevel["H2"] = "h2";
  HeadingLevel["H3"] = "h3";
  HeadingLevel["H4"] = "h4";
  HeadingLevel["H5"] = "h5";
  HeadingLevel["H6"] = "h6";
})(HeadingLevel || (HeadingLevel = {}));
var AriaCurrent;
(function (AriaCurrent) {
  AriaCurrent["Page"] = "page";
  AriaCurrent["Step"] = "step";
  AriaCurrent["Location"] = "location";
  AriaCurrent["Date"] = "date";
  AriaCurrent["Time"] = "time";
})(AriaCurrent || (AriaCurrent = {}));
var LoggerLevels;
(function (LoggerLevels) {
  LoggerLevels["Log"] = "log";
  LoggerLevels["Warn"] = "warn";
  LoggerLevels["Error"] = "error";
})(LoggerLevels || (LoggerLevels = {}));
var ComponentGroup;
(function (ComponentGroup) {
  ComponentGroup["Form"] = "Form";
  ComponentGroup["Layout"] = "Layout";
  ComponentGroup["Presentation"] = "Presentation";
  ComponentGroup["InteractivePanels"] = "Interactive Panels";
  ComponentGroup["AlertsMessaging"] = "Alerts and messaging";
  ComponentGroup["Utilities"] = "Utilities";
  ComponentGroup["NavigationMenus"] = "Navigation and menus";
})(ComponentGroup || (ComponentGroup = {}));
var DisplayMode;
(function (DisplayMode) {
  DisplayMode["Inline"] = "inline";
  DisplayMode["Overlay"] = "overlay";
})(DisplayMode || (DisplayMode = {}));
var PopperAlign;
(function (PopperAlign) {
  PopperAlign["Auto"] = "auto";
  PopperAlign["BottomStart"] = "bottom-start";
  PopperAlign["BottomCenter"] = "bottom";
  PopperAlign["BottomEnd"] = "bottom-end";
  PopperAlign["TopStart"] = "top-start";
  PopperAlign["TopCenter"] = "top";
  PopperAlign["TopEnd"] = "top-end";
  PopperAlign["LeftStart"] = "left-start";
  PopperAlign["LeftCenter"] = "left";
  PopperAlign["LeftEnd"] = "left-end";
  PopperAlign["RightStart"] = "right-start";
  PopperAlign["RightCenter"] = "right";
  PopperAlign["RightEnd"] = "right-end";
})(PopperAlign || (PopperAlign = {}));

export { AriaCurrent as A, Breakpoint as B, CaptureValues as C, DisplayMode as D, FormElementType as F, GlobalCssClass as G, HeadingLevel as H, LoggerLevels as L, PaddingSize as P, SystemValidationStatus as S, TextFieldType as T, FieldErrorType as a, TextAlign as b, GlobalBreakpointMinWidth as c, ComponentGroup as d, PopperAlign as e };
